export function polarToCartesian(cx: number, cy: number, r: number, angleRad: number) {
  return { x: cx + r * Math.cos(angleRad), y: cy + r * Math.sin(angleRad) };
}

export function buildArcPath(
  cx: number,
  cy: number,
  r: number,
  startFraction: number,
  endFraction: number,
) {
  const clampedEnd = Math.min(endFraction, startFraction + 0.9999);
  const startRad = startFraction * 2 * Math.PI - Math.PI / 2;
  const endRad = clampedEnd * 2 * Math.PI - Math.PI / 2;
  const start = polarToCartesian(cx, cy, r, startRad);
  const end = polarToCartesian(cx, cy, r, endRad);
  const largeArc = clampedEnd - startFraction > 0.5 ? 1 : 0;
  return `M ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 1 ${end.x} ${end.y}`;
}
